import React from 'react';
import css from './NumberInput.module.css';
import BasicButton from '@shared/Ui/Buttons/BasicButton/BasicButton';

interface CustomNumberInputProps
    extends React.InputHTMLAttributes<HTMLInputElement> {
    value?: number;
    increase?: () => void;
    decrease?: () => void;

    inputClassName?: string;
    controlsClassName?: string;
    decrementBtnClassName?: string;
    incrementBtnClassName?: string;

    disabled?: boolean;
    incrementDisabled?: boolean;
    decrementDisabled?: boolean;
}

const CustomNumberInput: React.FC<CustomNumberInputProps> = ({
    value = 0,
    increase,
    decrease,

    inputClassName = css.quantityInput,
    controlsClassName = css.changeQuantity,
    decrementBtnClassName = css.decrement,
    incrementBtnClassName = css.increment,

    onChange = () => {},
    disabled,
    incrementDisabled,
    decrementDisabled,
    ...inputProps
}) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value;
        const parsedValue =
            inputValue === ''
                ? undefined
                : Number(inputValue.replace(/^0+/, ''));
        const syntheticEvent = {
            ...e,
            target: {
                ...e.target,
                value: parsedValue !== undefined ? parsedValue.toString() : '',
            },
        };
        onChange(syntheticEvent);
    };

    return (
        <div className={inputClassName}>
            {!disabled && (
                <BasicButton
                    className={`${controlsClassName} ${decrementBtnClassName}`}
                    disabled={disabled || decrementDisabled}
                    onClick={decrease}
                >
                    -
                </BasicButton>
            )}

            <input
                type="text"
                disabled={disabled}
                value={value}
                onChange={handleChange}
                maxLength={25}
                {...inputProps}
            />

            {!disabled && (
                <BasicButton
                    className={`${controlsClassName} ${incrementBtnClassName}`}
                    onClick={increase}
                    disabled={disabled || incrementDisabled}
                >
                    +
                </BasicButton>
            )}
        </div>
    );
};

export default React.memo(CustomNumberInput);
